import { COLOR_KEYS } from '../../../constants';
import { SplitColorHeroProps } from './SplitColorHero';

export const DEFAULT_VALUES: SplitColorHeroProps = {
  animationShouldLoop: false,
  backgroundColor: COLOR_KEYS.zapier,
  ctaText: 'Get started free',
  ctaUrl: 'https://zapier.com/sign-up/',
  headingStaticText: 'Automate your',
  headingRotatingText: [
    { text: 'busywork' },
    { text: 'sales outreach' },
    { text: 'side hustle' },
    { text: 'lead flow' },
    { text: 'to-do list' },
    { text: 'team updates' },
    { text: 'social posts' },
    { text: 'copy/paste' },
    { text: 'opportunities' },
    { text: 'contracts' },
    { text: 'data entry' },
    { text: 'possibilities' },
    { text: 'way forward' },
  ],
  mediaAltText: 'Image of happy person',
  imageUrl: 'https://cdn.zappy.app/3dd21d692fdcfe9f6de827aff28c162a.png',
  description:
    '<p>Zapier connects the apps you use for work automatically. When your work is on autopilot you can focus on bigger better things.</p>',
};
